import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";

import { sortStockpilesByDistance } from "../../utils/create-table-data";
import { singleStockpileType } from "../../queries/types";
import { MatchContext } from "../../context";
import { GET_LOW_TONNAGE_EVENTS } from "../../queries/stockpiles.gql";
import { SET_HIGHLIGHTED_COLS } from "../../reduce/actionTypes";
import { APP_INSIGHTS_EVENTS } from "../../constants";
import StyledTableCell from "./styled-table-cell.component";
import StubCell from "./stub-cell.component";
import useStyles from "../tables-container/styles";
import useHighlightTableItem from "../../utils/hooks/use-higlight-table-item";

const StockpileHeader = ({
  data,
  handleStockpileDoubleClick,
  handleStockpileHover,
  hoveredStockpile,
  columnsNumber,
}): JSX.Element => {
  const classes = useStyles();
  const { state } = useContext(MatchContext);
  const [headerStockpiles, setHeaderStockpiles] = useState<
    singleStockpileType[] | []
  >([]);
  const [lteStockpiles, setLteStockpiles] = useState([]);
  const higlightTableItem = useHighlightTableItem();

  const [getLte] = useLazyQuery(GET_LOW_TONNAGE_EVENTS, {
    onCompleted: (data) => {
      let lteData = data.getLowTonnageEvents.lte;

      setLteStockpiles(
        Object.entries(lteData)
          .filter((item) => item[1] === 1)
          .map((item) => item[0])
      );
    },
  });

  useEffect(() => {
    if (data.length) {
      getLte({
        variables: {
          stockpiles: Object.values(
            data[0].stockpiles.map((item) => item.stockpile)
          ),
        },
      });
      setHeaderStockpiles(sortStockpilesByDistance(data[0].stockpiles));
    }
  }, [data]);

  if (!data)
    return (
      <React.Fragment>
        <StubCell columnsNumber={columnsNumber}></StubCell>
      </React.Fragment>
    );

  const prepareStyles = (stockpile) => {
    let classNames = `${classes.dataCell}`;

    if (state.highlightedCols.includes(stockpile))
      classNames += " highlighted-header";
    if (state.forecastedStockpile === stockpile)
      classNames += " double-highlighted-header";

    //highlighted-on-hover
    if (hoveredStockpile === stockpile)
      classNames += " highlighted-on-header-hover";

    return classNames;
  };

  return (
    <React.Fragment>
      {data &&
        // @ts-ignore
        headerStockpiles?.map((item) => (
          <StyledTableCell
            key={item.stockpile}
            align="center"
            className={prepareStyles(item.stockpile)}
            onClick={() =>
              higlightTableItem(
                item.stockpile,
                SET_HIGHLIGHTED_COLS,
                "highlightedCols",
                APP_INSIGHTS_EVENTS.CHANGE_COL_HIGHLIGHT
              )
            }
            onDoubleClick={() => handleStockpileDoubleClick(item.stockpile)}
            onMouseEnter={() => handleStockpileHover(item.stockpile)}
            onMouseLeave={() => handleStockpileHover("")}
          >
            {lteStockpiles.includes(item.stockpile)
              ? `LTE ${item.stockpile}`
              : item.stockpile}
          </StyledTableCell>
        ))}
    </React.Fragment>
  );
};

export default StockpileHeader;
